const buildAffidavitDataFetchObject = (applicantId, uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      clist: "32",
      ApplicantId: applicantId,
      fmt: "structured",
    },
  };

     if (applicantId) {
    dataObject.qdbapi.query = `{'7'.EX.'${applicantId}'}`;
  }
  return dataObject;
};

export default buildAffidavitDataFetchObject;